var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable lines-around-comment */
import { faArrowUpFromBracket, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardContent, Card } from "@material-ui/core";
import { withStyles } from "@mui/styles";
import React, { Component } from "react";
import participantsPaneTheme from "../../../base/components/themes/participantsPaneTheme.json";
import { translate } from "../../../base/i18n/functions";
import { IconClose } from "../../../base/icons/svg";
import { connect } from "../../../base/redux/functions";
import ClickableIcon from "../../../base/ui/components/web/ClickableIcon";
// @ts-ignore
import { close } from "../../actions";
// @ts-ignore
import { getMaterialListOpen } from "../../functions";
import i18n from "i18next";
const styles = (theme) => {
    return {
        container: {
            boxSizing: "border-box",
            flex: 1,
            overflowY: "auto",
            position: "relative",
            padding: `0 ${participantsPaneTheme.panePadding}px`,
            [`& > * + *:not(.${participantsPaneTheme.ignoredChildClassName})`]: {
                marginTop: theme.spacing(3),
            },
            "&::-webkit-scrollbar": {
                display: "none",
            },
        },
        closeButton: {
            alignItems: "center",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
        },
        header: {
            height: "60px",
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "16px",
            alignItems: "center",
            boxSizing: "border-box",
            color: "#fff",
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "32px",
            backgroundColor: "black",
        },
        antiCollapse: {
            fontSize: 0,
            "&:first-child": {
                display: "none",
            },
            "&:first-child + *": {
                marginTop: 0,
            },
        },
        btnHeader: {
            display: "flex",
            marginTop: "12px",
        },
        lectureNoteNav: {
            display: "flex",
            marginLeft: "auto",
            maxHeight: "33px"
        },
        lectureNoteButton: {
            border: "1px solid gray",
            backgroundColor: "#fff",
            color: "rgba(0,0,0)",
            borderRadius: "0.5rem",
            padding: "8px 8px 8px 8px",
            fontWeight: 500,
            fontSize: "15px",
            outline: "none",
        },
        materialTitle: {
            fontWeight: 800,
            textAlign: "center",
        },
        fileState: {
            display: "flex",
            alignItems: "center",
            color: "#fff",
            marginLeft: "5px",
            fontSize: "5px",
        },
        fileContent: {
            backgroundColor: "#333",
            color: "#fff",
        },
        selectFile: {
            width: '300px',
            padding: '5px',
            border: '1px solid #999',
            fontFamily: 'Nanumgothic',
            background: 'url("https://i.ibb.co/98Vbb8L/gnb-bg.gif") no-repeat 95% 50%)',
            borderRadius: '3px',
            appearance: 'none',
        },
        downloadFile: {
            border: "1px solid gray",
            backgroundColor: "#fff",
            color: "rgba(0,0,0)",
            borderRadius: "0.5rem",
            fontWeight: 800,
            fontSize: "10px",
            outline: "none",
            marginBottom: "5px"
        }
    };
};
/**
 * Implements the material list.
 */
class MaterialList extends Component {
    //  private titleFocus = createRef<HTMLDivElement>();
    /**
     * Initializes a new {@code ParticipantsPane} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        /**
         * Implements React's {@link Component#componentWillUnmount()}.
         *
         * @inheritdoc
         */
        /**
         * Implements React's {@link Component#render}.
         *
         * @inheritdoc
         */
        // @ts-ignore
        this.fileState = () => {
            const { t } = this.props;
            if (this.state.selectedFile) {
                return (React.createElement("div", null,
                    this.state.selectedFile.name,
                    React.createElement("br", null),
                    t("materialList.uploading")));
            }
            else if (this.state.uploadedFile === true) {
                return (React.createElement("div", null, t("materialList.complete")));
            }
            else if (!this.state.selectedFile) {
                return React.createElement("div", null, "\u3164\u3164");
            }
        };
        this._onFileChange = (event) => {
            this.setState({ selectedFile: event.target.files[0] });
            this._onUploadFile();
        };
        this.state = {
            uploadedFile: false,
            selectedFile: null,
            content: {
                id: 0,
                text: "",
                braille: "",
                maxPageNum: 0,
            },
            pageNum: 0,
            pageCount: 0,
            isFetching: false,
            isTrans: false,
            isNavigate: false,
        };
        this.classId = "";
        this.isTranslatedBraille = true;
        this.isServiceForVisionLoss = false;
        // @ts-ignore
        this.pageNumUpdateInterval = null;
        // @ts-ignore
        this.fileListUpdateInterval = null;
        this.fileList = [];
        this.downloadFileList = [];
        this.fileData = {};
        // Bind event handlers so they are only bound once per instance.
        this._onCloseList = this._onCloseList.bind(this);
        this._onFileClick = this._onFileClick.bind(this);
        this._onFileChange = this._onFileChange.bind(this);
        this._onUploadFile = this._onUploadFile.bind(this);
        this._onGetRecentFile = this._onGetRecentFile.bind(this);
        this._onGoToTeacherPage = this._onGoToTeacherPage.bind(this);
        this._onUpdatePageNumForTeacher = this._onUpdatePageNumForTeacher.bind(this);
        this._onUpdatePageNumForStudent = this._onUpdatePageNumForStudent.bind(this);
        this._onPreviousPage = this._onPreviousPage.bind(this);
        this._onNextPage = this._onNextPage.bind(this);
        this._onUpdateFileList = this._onUpdateFileList.bind(this);
        this._onFileSelect = this._onFileSelect.bind(this);
        this._onGetDownloadFile = this._onGetDownloadFile.bind(this);
        this._onDownloadButtonClick = this._onDownloadButtonClick.bind(this);
        this._onDeleteButtonClick = this._onDeleteButtonClick.bind(this);
        this._onDisplayBrailleCard = this._onDisplayBrailleCard.bind(this);
        this._refreshFileList = this._refreshFileList.bind(this);
        this._onChangeNavigationOrder = this._onChangeNavigationOrder.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        const roomId = location.pathname;
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" }
        }).then(res => {
            if (res.status === 200) {
                res.json().then((data) => {
                    this.classId = data.onlineClassId;
                    this.isServiceForVisionLoss = data.serviceForVisionLoss;
                    this._onGetRecentFile();
                    this._onUpdateFileList();
                    this._onGetDownloadFile();
                });
            }
        });
        //Keyboard shortcuts for previous page, next page, teacher's button of Note component
        APP.keyboardshortcut.registerShortcut('X', 'previousPage', this._onPreviousPage, 'keyboardShortcuts.previousPage', true),
            APP.keyboardshortcut.registerShortcut('N', 'nextPage', this._onNextPage, 'keyboardShortcuts.nextPage', true),
            APP.keyboardshortcut.registerShortcut('Q', 'goToTeacherPage', this._onGoToTeacherPage, 'keyboardShortcuts.goToTeacherPage', true);
    }
    componentWillUnmount() {
        APP.keyboardshortcut.unregisterShortcut('X', true);
        APP.keyboardshortcut.unregisterShortcut('N', true);
        APP.keyboardshortcut.unregisterShortcut('Q', true);
    }
    // @ts-ignore
    componentDidUpdate(prevProps, prevState) {
        // 이전 props, state에 대한 정보
        if (!prevProps._isListOpen && this.props._isListOpen) {
            const heading = document.getElementById("material_list-heading");
            if (heading) {
                heading.focus();
            }
            if (this.fileListUpdateInterval == null) {
                this.fileListUpdateInterval = setInterval(() => {
                    this._refreshFileList();
                }, 8000);
                if (!this.props._isTeacher && !this.props._isPreUser && this.isServiceForVisionLoss) {
                    this.pageNumUpdateInterval = setInterval(() => {
                        this._onUpdatePageNumForStudent();
                    }, 2000);
                }
            }
        }
        else if (prevProps._isListOpen && !this.props._isListOpen) {
            if (this.fileListUpdateInterval != null) {
                // @ts-ignore
                clearInterval(this.fileListUpdateInterval);
                // @ts-ignore
                this.fileListUpdateInterval = null;
            }
            if (this.pageNumUpdateInterval != null) {
                // @ts-ignore
                clearInterval(this.pageNumUpdateInterval);
                // @ts-ignore
                this.pageNumUpdateInterval = null;
            }
        }
        if (prevState.pageNum !== this.state.pageNum ||
            this.props._isListOpen) {
            try {
                // @ts-ignore
                MathJax.typeset();
            }
            catch (e) {
                console.log(e);
            }
        }
        if (prevState.content.id !== this.state.content.id) {
            // this._onGetRecentFile();
        }
        // @ts-ignore
        if (prevProps.downloadFileList != this.props.downloadFileList) {
            // @ts-ignore
            {
                this.downloadFileList.map((file, index));
            }
        }
    }
    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { _isListOpen, classes, t } = this.props;
        if (!_isListOpen) {
            return null;
        }
        let textContent = "";
        let brailleContent = "";
        if (this.state.content.id != 0 &&
            this.state.content.maxPageNum != 0 &&
            this.state.pageNum < this.state.content.maxPageNum) {
            // @ts-ignore
            textContent = this.fileData[this.state.content.id].text[this.state.pageNum];
            // @ts-ignore
            brailleContent = this.fileData[this.state.content.id].braille[this.state.pageNum];
        }
        else {
            textContent = t('materialList.textContent');
            brailleContent = t('materialList.brailleContent');
        }
        return (React.createElement("div", { className: "participants_pane" },
            React.createElement("div", { className: "participants_pane-content" },
                React.createElement("div", { className: classes.header },
                    React.createElement("h2", { id: "material_list-heading", style: {
                            color: "#fff",
                        }, tabIndex: 0 }, t("materialList.title")),
                    React.createElement(ClickableIcon, { accessibilityLabel: t("materialList.close", "Close"), icon: IconClose, onClick: this._onCloseList })),
                React.createElement("div", { className: classes.container },
                    React.createElement("div", { className: classes.btnHeader },
                        (this.props._isPreUser || this.props._isTeacher) &&
                            React.createElement(React.Fragment, null,
                                React.createElement("button", { "aria-label": t("materialList.upload"), className: classes.lectureNoteButton, onClick: this._onFileClick },
                                    React.createElement(FontAwesomeIcon, { icon: faArrowUpFromBracket })),
                                React.createElement("input", { hidden: true, id: "files", onChange: this._onFileChange, type: "file" })),
                        React.createElement("div", { hidden: !this.props._isTeacher && !this.props._isPreUser, style: {
                                display: "flex",
                                alignItems: "center",
                            } },
                            React.createElement("div", { className: classes.fileState }, this.fileState())),
                        this.isServiceForVisionLoss &&
                            ((this.props._isTeacher || this.props._isPreUser) || this.state.isNavigate &&
                                !(this.props._isTeacher || this.props._isPreUser)) &&
                            React.createElement("div", { id: 'lectureNoteNav', className: classes.lectureNoteNav },
                                React.createElement("button", { "aria-label": t("materialList.previousPage"), className: classes.lectureNoteButton, onClick: this._onPreviousPage, style: {
                                        marginRight: "7px",
                                    } },
                                    React.createElement(FontAwesomeIcon, { icon: faArrowLeft })),
                                React.createElement("button", { "aria-label": t("materialList.nextPage"), className: classes.lectureNoteButton, onClick: this._onNextPage },
                                    React.createElement(FontAwesomeIcon, { icon: faArrowRight })))),
                    this.isServiceForVisionLoss && React.createElement(React.Fragment, null,
                        React.createElement("div", { style: {
                                display: 'flex',
                                justifyContent: 'space-between'
                            }, id: 'fileSelectBox' },
                            React.createElement("select", { name: "fileSelect", id: "file-select", onChange: this._onFileSelect },
                                React.createElement("option", { value: "initOption", selected: true }, t('materialList.selectLectureNote')),
                                this.fileList.map((file, index) => (
                                // @ts-ignore
                                React.createElement("option", { key: file.id, 
                                    // @ts-ignore
                                    value: file.id }, file.filename)))),
                            !(this.props._isTeacher || this.props._isPreUser) &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("label", { htmlFor: 'checkNavigate', style: {
                                            color: 'fff'
                                        } }, "\uB0B4\uAC00 \uB118\uAE30\uAE30"),
                                    React.createElement("input", { id: 'checkNavigate', onChange: this._onChangeNavigationOrder, type: "checkbox" }))),
                        React.createElement(Card, { id: 'textCard', className: classes.fileContent },
                            React.createElement(CardContent, null,
                                React.createElement("h4", { className: classes.materialTitle, style: {
                                        color: "#fff",
                                    }, tabIndex: 0 }, t('materialList.originalLecture')),
                                React.createElement("hr", null),
                                React.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: textContent,
                                    }, tabIndex: 0 }))),
                        React.createElement(Card, { id: 'brailleCard', className: classes.fileContent },
                            React.createElement(CardContent, { style: {
                                    wordBreak: "break-all",
                                } },
                                React.createElement("h4", { className: classes.materialTitle, style: {
                                        color: "#fff",
                                    }, tabIndex: 0 }, t('materialList.brailleLecture')),
                                React.createElement("hr", null),
                                React.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: brailleContent,
                                    }, tabIndex: 0 })))),
                    React.createElement(Card, null,
                        React.createElement(CardContent, null,
                            React.createElement("h4", { className: classes.materialTitle, style: {
                                    color: 'black',
                                }, tabIndex: 0 }, t('materialList.downloadList')),
                            React.createElement("hr", null),
                            React.createElement("ul", null,
                                React.createElement("p", { hidden: true, id: 'downloadListEmpty' }, t("materialList.downloadEmpty")),
                                this.downloadFileList.map((file, index) => (
                                // @ts-ignore
                                React.createElement("li", { key: file.id, value: file.id },
                                    file.filename,
                                    React.createElement("button", { "aria-label": t("materialList.downloadList"), className: classes.downloadFile, 
                                        // @ts-ignore
                                        id: file.id, onClick: this._onDownloadButtonClick, "data-name": file.filename }, t('materialList.downloadFile')),
                                    (this.props._isTeacher || this.props._isPreUser) &&
                                        React.createElement("button", { "aria-label": '\uC0AD\uC81C', 
                                            // @ts-ignore
                                            id: file.id, onClick: this._onDeleteButtonClick, "data-name": file.filename, className: classes.downloadFile }, "\uC0AD\uC81C")))))))))));
    }
    _refreshFileList() {
        this._onUpdateFileList();
        this._onGetDownloadFile();
    }
    _onDisplayBrailleCard() {
        const roomId = location.pathname;
        // @ts-ignore
        const brailleCard = document.getElementById('brailleCard');
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { 'Content-Type': 'application/json' }
        }).then(res => {
            if (res.status == 200) {
                res.json().then(data => {
                    if (!data.serviceForVisionLoss) {
                        //@ts-ignore
                        brailleCard.hidden = true;
                    }
                    else {
                        if (this.state.content.braille.length == 0) {
                            // @ts-ignore
                            brailleCard.hidden = true;
                        }
                        else {
                            // @ts-ignore
                            brailleCard.hidden = false;
                        }
                    }
                });
            }
        });
    }
    _onUpdateFileList() {
        fetch(`/livi/api/onlineclass/${this.classId}/handout?type=filenames&isAllowedDownload=false`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => {
                    if (this.downloadFileList)
                        this.fileList = [];
                    for (let i = 0; i < data.length; i++) {
                        // @ts-ignore
                        this.fileList.push({ 'filename': data[i].originalFilename, 'id': data[i].id, 'isTranslatedBraille': data[i].isTranslatedBraille });
                        this.isTranslatedBraille = data[i].isTranslatedBraille;
                    }
                    // @ts-ignore
                    this.fileList.sort((a, b) => b.id - a.id);
                    this.setState({ isFetching: true });
                });
            }
        });
    }
    _onFileSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            if (this.fileData[e.target.value] == null) {
                yield this._onGetRecentFile();
            }
            // @ts-ignore
            if (this.fileData[e.target.value] != null) {
                this.setState({
                    content: {
                        // @ts-ignore
                        id: e.target.value,
                        // @ts-ignore
                        text: this.fileData[e.target.value].text,
                        // @ts-ignore
                        braille: this.fileData[e.target.value].braille,
                        // @ts-ignore
                        maxPageNum: this.fileData[e.target.value].maxPageNum
                    },
                    pageNum: 0,
                }, () => {
                    this._onDisplayBrailleCard();
                    if (this.props._isTeacher || this.props._isPreUser) {
                        this._onUpdatePageNumForTeacher(0);
                    }
                });
            }
            else {
                this.setState({
                    content: {
                        // @ts-ignore
                        id: e.target.value,
                        // @ts-ignore
                        text: '',
                        // @ts-ignore
                        braille: '',
                        // @ts-ignore
                        maxPageNum: 0
                    },
                    pageNum: 0
                });
                // @ts-ignore
                const brailleCard = document.getElementById('brailleCard');
                // @ts-ignore\
                brailleCard.hidden = false;
                setTimeout(this._onUpdateFileList, 1000);
                // TODO : 없는 파일을 선택해서 다시 파일을 다운로드 필요
                // 현재 상태는 초기값을 선택해야 main 페이지에 맞게 refresh 하여 동작
            }
        });
    }
    _onGetDownloadFile() {
        fetch(`/livi/api/onlineclass/${this.classId}/handout?type=filenames&isAllowedDownload=true`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => {
                    this.downloadFileList = [];
                    for (let i = 0; i < data.length; i++) {
                        // @ts-ignore
                        this.downloadFileList.push({ 'filename': data[i].originalFilename, 'id': data[i].id });
                    }
                    // @ts-ignore
                    this.downloadFileList.sort((a, b) => b.id - a.id);
                    const downloadListEmpty = document.getElementById('downloadListEmpty');
                    if (downloadListEmpty) {
                        if (this.downloadFileList.length == 0) {
                            // @ts-ignore
                            downloadListEmpty.hidden = false;
                        }
                        else {
                            // @ts-ignore
                            downloadListEmpty.hidden = true;
                        }
                    }
                    this.setState({ isFetching: true });
                });
            }
        });
    }
    _onDownloadButtonClick(e) {
        if (confirm(i18n.t("materialList.downloadFileAlert"))) {
            fetch(`/livi/api/onlineclass/${this.classId}/handout/${e.target.id}`).
                then((res) => { return res.blob(); })
                .then((data) => {
                let a = document.createElement("a");
                // @ts-ignore
                a.href = window.URL.createObjectURL(data);
                a.download = e.target.dataset.name;
                a.click();
            });
        }
        else {
            return;
        }
    }
    _onDeleteButtonClick(e) {
        if (confirm('선택한 파일을 삭제하시겠습니까?')) {
            fetch(`/livi/api/onlineclass/${this.classId}/handout/${e.target.id}`, {
                method: "DELETE"
            }).then((res) => {
                if (res.status === 200) {
                    console.log('delete file complete');
                    this._onGetDownloadFile();
                }
            });
        }
        else {
            return;
        }
    }
    _onChangeNavigationOrder() {
        // @ts-ignore
        this.setState({ isNavigate: document.getElementById('checkNavigate').checked }, () => {
            if (this.state.isNavigate) {
                // @ts-ignore
                clearInterval(this.pageNumUpdateInterval);
            }
            else {
                // @ts-ignore
                this.pageNumUpdateInterval = setInterval(() => {
                    this._onUpdatePageNumForStudent();
                }, 2000);
            }
        });
    }
    /**
     * Callback for closing the participant pane.
     *
     * @private
     * @returns {void}
     */
    _onCloseList() {
        // 더보기 메뉴에 버튼이 들어깄을 때 예외처리
        const toolbar = document.getElementById("toolbar-material_list");
        if (toolbar && toolbar.firstChild) {
            // @ts-ignore
            toolbar.firstChild.focus();
        }
        this.props.dispatch(close());
    }
    _onFileClick() {
        $("#files").trigger("click");
    }
    _onUploadFile() {
        const roomId = location.pathname;
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => {
                    this.setState({ isTrans: data.translatingType }, () => {
                        // 파일 업로드 버튼 누를 때
                        const formData = new FormData();
                        // @ts-ignore
                        const files = document.getElementById("files").files;
                        for (let i = 0; i < files.length; i++) {
                            formData.append("file", files[i]);
                        }
                        formData.append("toBraille", this.state.isTrans.toString());
                        fetch(`/livi/api/onlineclass/${this.classId}/handout2`, {
                            method: "POST",
                            body: formData,
                        }).then((res) => __awaiter(this, void 0, void 0, function* () {
                            if (res.status === 200) {
                                this.setState({ selectedFile: null });
                                this.setState({ uploadedFile: true }, () => {
                                    this._onUpdateFileList();
                                    this._onGetDownloadFile();
                                });
                                $("#files").val(""); // 파일 초기화
                                this._onGetRecentFile();
                            }
                            else if (res.status === 400) {
                                try {
                                    const data = yield res.json();
                                    alert(data[0].defaultMessage);
                                }
                                catch (e) {
                                    alert("Failed .. ");
                                }
                                this.setState({ selectedFile: null });
                            }
                            else {
                                alert("파일 업로드에 실패했습니다.");
                                this.setState({ selectedFile: null });
                            }
                        }));
                    });
                });
            }
            else {
                alert("파일 업로드에 실패했습니다.");
                this.setState({ selectedFile: null });
            }
        });
    }
    _onGetRecentFile() {
        fetch(`/livi/api/onlineclass/${this.classId}/handout`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => {
                    //@ts-ignore
                    data.sort((a, b) => b.id - a.id);
                    for (let i = 0; i < data.length; i++) {
                        //let text=data[i].content.split("<hr/>"); db에 brf 파일이 같이 있기 때문에 선언하면 split이 안됨
                        // @ts-ignore
                        this.fileData[data[i].id] = {
                            'text': data[i].content == null ? [] : data[i].content.split("<hr/>"),
                            'braille': data[i].translatedContent == null ? [] : data[i].translatedContent.split("<hr/>"),
                            'maxPageNum': data[i].content == null ? 0 : data[i].content.split("<hr/>").length
                        };
                    }
                    // @ts-ignore
                    if (this.fileData != null) {
                        this.setState({
                            content: {
                                // @ts-ignore
                                id: data[0].id,
                                // @ts-ignore
                                text: this.fileData[data[0].id].text,
                                // @ts-ignore
                                braille: this.fileData[data[0].id].braille,
                                // @ts-ignore
                                maxPageNum: this.fileData[data[0].id].length,
                            },
                            pageNum: 0,
                        });
                    }
                });
            }
        });
    }
    _onUpdatePageNumForTeacher(pageNum) {
        const roomId = location.pathname;
        const data = {
            fileId: this.state.content.id,
            currentPage: pageNum,
        };
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        }).then((res) => {
            if (res.status === 200) {
                console.log("successfully updated");
            }
        });
    }
    _onGoToTeacherPage() {
        const roomId = location.pathname;
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => __awaiter(this, void 0, void 0, function* () {
                    const id = Number(data.currentHandOutId);
                    const pageNum = Number(data.currentPageNum);
                    // @ts-ignore
                    if (this.fileData != null) {
                        // @ts-ignore
                        if (this.fileData[id] == null) {
                            yield this._onGetRecentFile();
                        }
                        this.setState({
                            content: {
                                // @ts-ignore
                                id: id,
                                // @ts-ignore
                                text: this.fileData[id].text,
                                // @ts-ignore
                                braille: this.fileData[id].braille,
                                // @ts-ignore
                                maxPageNum: this.fileData[id].maxPageNum,
                            },
                            pageNum: pageNum,
                        });
                    }
                }));
            }
        });
    }
    _onUpdatePageNumForStudent() {
        const roomId = location.pathname;
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => __awaiter(this, void 0, void 0, function* () {
                    // @ts-ignore
                    const id = Number(data.currentHandOutId);
                    // @ts-ignore
                    const pageNum = Number(data.currentPageNum);
                    // @ts-ignore
                    if (this.fileData != null) {
                        // @ts-ignore
                        if (this.fileData[id] == null) {
                            yield this._onGetRecentFile();
                        }
                        this.setState({
                            content: {
                                // @ts-ignore
                                id: id,
                                // @ts-ignore
                                text: this.fileData[id].text,
                                // @ts-ignore
                                braille: this.fileData[id].braille,
                                // @ts-ignore
                                maxPageNum: this.fileData[id].maxPageNum,
                            },
                            pageNum: pageNum,
                        });
                    }
                }));
            }
        });
    }
    _onPreviousPage() {
        const newPageNum = Math.max(this.state.pageNum - 1, 0);
        if (this.state.pageNum === 0) {
            //Play the sound instead of pop up when first page is reached in lectures list
            const audio = new Audio("./sounds/noPage.wav");
            audio.volume = 0.2;
            audio.play();
            //alert("첫번째 페이지입니다!"); --> Just commented it in case it will be needed later on
            return;
        }
        this.setState({
            pageNum: newPageNum,
        });
        if (this.props._isTeacher || this.props._isPreUser) {
            this._onUpdatePageNumForTeacher(newPageNum);
        }
    }
    _onNextPage() {
        const newPageNum = Math.min(this.state.pageNum + 1, this.state.content.maxPageNum - 1);
        if (newPageNum === this.state.content.maxPageNum - 1) {
            //Play a sound instead of pop up when last page is reached in lectures list
            const audio = new Audio("./sounds/noPage.wav");
            audio.volume = 0.2;
            audio.play();
            //alert("마지막 페이지입니다!");--> Just commented it in case it will be needed later on
            return;
        }
        this.setState({
            pageNum: newPageNum,
        });
        if (this.props._isTeacher || this.props._isPreUser) {
            this._onUpdatePageNumForTeacher(newPageNum);
        }
    }
}
/**
 * Maps (parts of) the redux state to the React {@code Component} props of
 * {@code ParticipantsPane}.
 *
 * @param {Object} state - The redux state.
 * @protected
 * @returns {Props}
 */
function _mapStateToProps(state) {
    const isListOpen = getMaterialListOpen(state);
    const { isLogin, isTeacher, isPreUser, serviceForVisionLoss } = state["features/base/conference"];
    return {
        _isListOpen: isListOpen,
        _isLogin: isLogin,
        _isTeacher: isTeacher,
        _isPreUser: isPreUser,
        _serviceForVisionLoss: serviceForVisionLoss
    };
}
// @ts-ignore
export default translate(
// @ts-ignore
connect(_mapStateToProps)(withStyles(styles)(MaterialList)));
